import React from "react";
import { createRoot } from "react-dom/client";

// Les fontes AVANT le reste : elles sont servies depuis notre domaine, et leur
// déclaration doit précéder la feuille qui les référence.
//
// POINT D'EXTENSION — une seule fonte pour l'instant, celle de l'interface.
// Le caractère de titrage du château viendra s'ajouter ici, et se déclarer
// dans `typography.css`.
import "@fontsource-variable/inter";
// L'écran d'accueil : interface en Raleway (voir `--police-splash-*`). Le titre,
// lui, est Casablanca, déclarée en `@font-face` dans `typography.css`.
import "@fontsource-variable/raleway";
import "./typography.css";

import { App } from "./App.js";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
